import $ from 'jquery';
import breakpoint from '../scripts/breakpoint';
import '../../node_modules/sticky-sidebar-v2/dist/jquery.sticky-sidebar.min.js';

$.addInit(function(context){
	var base = '.b-filter';
	var desktop = $('.i-filter-lg');
	var mobile = $('.i-filter-xs');

	$(base, context).each(function(){
		var filter = $(this);
		var component = filter.find(base + '-inner');
		
		breakpoint('xs', 'lg')
			.onmatch(function(){
				component.appendTo(mobile);

				filter.stickySidebar('destroy');
				filter.removeData('stickySidebar');
			})
			.onmismatch(function(){
				component.appendTo(desktop);

				setTimeout(function() {
					var stickySidebarFilter = filter.stickySidebar({
						// topSpacing: 148,
						bottomSpacing: 20,
						innerWrapperSelector: base + '-inner',
					});
				});
			});
	});
});

$.addInit(function(context){
	var base = '.i-filter-xs';
	$(base, context).each(function(){
		var component = $(this);

		breakpoint('lg')
			.onmatch(function(){
				component.closest('.b-modal').trigger('close');
			});
	});
});